import api from './api';

const brandService = {
  /**
   * Obtener todas las marcas
   */
  async getAll(params = {}) {
    try {
      const response = await api.get('/brands', { params });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener marcas'
      };
    }
  },

  /**
   * Obtener marca por ID
   */
  async getById(id) {
    try {
      const response = await api.get(`/brands/${id}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener marca'
      };
    }
  },

  /**
   * Crear marca
   */
  async create(brandData) {
    try {
      const response = await api.post('/brands', brandData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear marca'
      };
    }
  },

  /**
   * Actualizar marca
   */
  async update(id, brandData) {
    try {
      const response = await api.put(`/brands/${id}`, brandData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar marca'
      };
    }
  },

  /**
   * Eliminar marca
   */
  async delete(id) {
    try {
      const response = await api.delete(`/brands/${id}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar marca'
      };
    }
  }
};

export default brandService;


